import { render, staticRenderFns } from "./StuList.vue?vue&type=template&id=1bdf7665&scoped=true"
import script from "./StuList.vue?vue&type=script&lang=js"
export * from "./StuList.vue?vue&type=script&lang=js"
import style0 from "./StuList.vue?vue&type=style&index=0&id=1bdf7665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf7665",
  null
  
)

export default component.exports